/**
 * Subscribes the active user to a watchable object.
 *
 * @author Marcel Werk
 * @copyright 2001-2026 WoltLab GmbH
 * @license GNU Lesser General Public License <http://opensource.org/licenses/lgpl-license.php>
 * @since 6.3
 * @woltlabExcludeBundle tiny
 */
define('WoltLabSuite/Core/Api/Users/ObjectWatches/Subscribe',["require", "exports", "WoltLabSuite/Core/Ajax/Backend", "../../Result"], function (require, exports, Backend_1, Result_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.subscribe = subscribe;
    async function subscribe(objectType, objectID, enableNotification) {
        return (0, Result_1.fromInfallibleApiRequest)(() => {
            return (0, Backend_1.prepareRequest)(`${window.WSC_RPC_API_URL}core/users/object-watches/subscribe`)
                .post({
                objectType,
                objectID,
                enableNotification,
            })
                .fetchAsJson();
        });
    }
});

